import useDemoHelper from "./useDemoHelper";
import step51 from "../../../../../assets/demo/emergency/5.1.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashButtonContact = () => {
        demoHelper.flash('[data-test="button-call-quotation-validation"]', 5);
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 7 seconds
            window.sound.src = step51;
            window.sound.play();

            flashButtonContact();

            await demoHelper.sleep(4000);
        }
    }
}